export const HEADER = "طلبات التحويل المتعدد";
export const WAITING_CASHOUTS_TAB = "بانتظار التحويل";
export const IN_PROGRESS_CASHOUTS_TAB = "جاري التحويل";
export const FAILED_CASHOUTS_TAB = "فشل التحويل";
export const BUTTON = {
  SEARCH_USER_ID: "كود المستخدم",
  SEARCH_CONTRACT_ID: "كود المعاملة",
};
export const TABLE_HEADERS = {
  USER_NAME: "المستخدم",
  WAITING_CASHOUTS_NUMBER: "عدد التحويلات بانتظار التحويل",
  CASHOUTS_NUMBER: "عدد التحويلات",
  TOTAL_AMOUNT: "القيمة الإجمالية",
};

export enum MultiCashoutStatus {
  WAITING = "WAITING",
  INITIATED = "INITIATED",
  COMPLETED = "COMPLETED",
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  FAILED = "FAILED",
}
